import React, { useState } from "react";
import {
  Row,
  Column,
  FormGroup,
  TextArea,
  TextInput,
} from "carbon-components-react";

const MarketAnalysisForm = ({ disabled, register, errors, isJury }) => {
  return (
    <FormGroup
      legendText="3	ANÁLISE DO MERCADO E MARKETING"
      className="section-header"
    >
      <h6 className="section-subtitle">
        [Instrução geral de preenchimento: esta secção tem como objectivo de
        conhecer o mercado em que seu negócio opera nas componentes de
        concorrentes e os canais de comunicação com os diferentes seguimentos de
        clientes.]
      </h6>

      <fieldset fieldset className="bx--fieldset">
        <legend className="bx--label">
          <h6 className="section-subtitle">3.1. Seguimento de Clientes</h6>
        </legend>
        <div className="bx--form__helper-text">
          [Instrução de preenchimento: Descreva os seus principais clientes,
          destacando o número aproximado, faixa etária e localização geográfica.
          Use no máximo 100 palavras.]
        </div>

        <Row>
          <Column xsm={12} sm={12} md={6} lg={6} className="required">
            <TextInput
              id="approximateNumberOfCustomers"
              labelText="3.1.1. Número aproximado de clientes:"
              disabled={disabled}
              {...register("approximateNumberOfCustomers")}
            />
            <p className="field-error">
              {errors.approximateNumberOfCustomers?.message}
            </p>
          </Column>
        </Row>

        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="customerDescription"
              labelText="3.1.2. Descrição dos Clientes (média de idade e sua localização em relação ao negócio, próximo ou distante)"
              rows={4}
              enableCounter
              disabled={disabled}
              helperText="[Use no máximo 100 palavras.]"
              {...register("customerDescription")}
            />
            <p className="field-error">{errors.customerDescription?.message}</p>
          </Column>
        </Row>
      </fieldset>

      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="productServiceImprovements"
              labelText="3.2 Descreva o que necessita melhorar nos seus produtos/serviços para superar os seus principais concorrentes."
              rows={4}
              enableCounter
              disabled={disabled}
              helperText="[Instrução de preenchimento: Use no máximo 100 palavras.]"
              {...register("productServiceImprovements")}
            />
            <p className="field-error">
              {errors.productServiceImprovements?.message}
            </p>
          </Column>
        </Row>
      </fieldset>

      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="marketingStrategiesAndChannels"
              labelText="3.3 Quais serão as suas principais estratégias e canais para publicar os seus produtos/serviços para angariar mais e diversificados clientes do mercado, principalmente dos seus concorrentes?"
              rows={4}
              enableCounter
              disabled={disabled}
              helperText="[Instrução de preenchimento: Use no máximo 100 palavras.]"
              {...register("marketingStrategiesAndChannels")}
            />
            <p className="field-error">
              {errors.marketingStrategiesAndChannels?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
    </FormGroup>
  );
};

MarketAnalysisForm.defaultProps = {
  disabled: false,
};
export default MarketAnalysisForm;
